import React from "react";
import LegalPage, { H2, P, UL } from "./LegalPage";

export default function Disclaimer() {
  return (
    <LegalPage title="Disclaimer">

      <P>
        The information provided on Grox24 and the Flavors feature is for general
        informational and convenience purposes only.
      </P>

      <H2>1. Nutrition & Health Information</H2>
      <P>
        Flavors provides general nutritional guidance and meal suggestions.
        This content is not medical advice and should not replace professional
        medical consultation. Users with medical conditions should consult a
        qualified healthcare professional before making dietary changes.
      </P>

      <H2>2. Service Availability</H2>
      <P>
        Grox24 strives to provide reliable service but does not guarantee
        uninterrupted availability of the platform, delivery services, or app
        functionality.
      </P>

      <H2>3. Product Representation</H2>
      <P>
        Product images shown in the app or website are for representation
        purposes only. Actual products may vary slightly in appearance,
        packaging, or size.
      </P>

    </LegalPage>
  );
}